/**
 * @generated SignedSource<<dd8542ac4f61627df7aa24dbedbe0818>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeRoleEditEmployeesListItem_query$data = {
  readonly employeesByIds: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditEmployeesListItem_employee">;
  } | null> | null;
  readonly " $fragmentType": "EmployeeRoleEditEmployeesListItem_query";
};
export type EmployeeRoleEditEmployeesListItem_query$key = {
  readonly " $data"?: EmployeeRoleEditEmployeesListItem_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditEmployeesListItem_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeRoleEditEmployeesListItem_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "ids",
          "variableName": "employeeIds"
        }
      ],
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employeesByIds",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeRoleEditEmployeesListItem_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b6872fdbf73c455d965938750c892c55";

export default node;
